import {
  Accordion,
  ControlledDropDown,
  CustomButton,
  DATE_INPUT_CONSTANTS,
  Modal,
  StickyHeaderAccordion,
  SvgReload,
  SvgRevalidate,
  Tooltip,
} from '@ui-kit'
import React, { FC, lazy, Suspense, useEffect, useRef, useState } from 'react'
import WorkflowTaskStatus from './WorkflowTaskStatus'
import { isEmpty } from 'lodash'
import {
  completeTaskByTaskIdApi,
  getTaskListApi,
  hideLoader,
  showLoader,
  WORKFLOW_UI_IDENTIFIER,
  taskUpdateApi,
  WorkflowInstanceTaskType,
  WorkflowTaskCompleteResponseType,
  interruptWorkFlow,
  getLayoutByIdApi,
  LayoutResponseType,
  updateWorkflowInstance,
  addToaster,
  setWorkflowStatus,
  saveTaskDataApi,
  fetchAssigneeApi,
  fetchAssigneeApiForPermissions,
  updateTaskList,
  PHARMACY_RE_TRIAGE_UI_IDENTIFIER,
  updateMaxRTEAutotriggered,
} from '@app-store'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import SendCommunicationTask from './SendCommunicationTask'
import AddTask, { CaseCreatedTask } from './SystemAutoTask'
import MissingInformationModal from './MissingInformationModal'
import {
  IMaxRTEButton,
  MapTaskOnUiIdentifierPropsType,
  MoveToMIProcessPropsType,
  TaskPayload,
  WorkflowRevalidateTaskPropsType,
  WorkflowRightSplitTaskTablePropsType,
} from '../../types/workflow.types'
import { FieldValues, useForm } from 'react-hook-form'
import { EntityLayout, LayoutData } from '../../types/layout.types'
import {
  editEntityData,
  editEntityDataEmbeddedAPI,
  getEntityData,
} from '../../apis/entityData.api'
import {
  NAMESPACES,
  WORKFLOW_OUTCOMES,
  WORKFLOW_STATUS,
} from '../../utils/constants'
import {
  ROWS_TAB_DIFFERENCE_FOR_WORK_FOW,
  ShortcutKeys,
} from '../../constants/form.constants'
import { v4 as uuid } from 'uuid'
import { MISSING_INFO_CONSTANTS } from '../../constants/missingInfoModal.constants'
import FormRenderer from '../FormRenderer'
import SendConsentTask from '../send-consent/SendConsentTask'
import { fetchTaskStatus } from '../../apis/workFlowTaskStatus.api'
import { STRINGS } from '../../utils/strings'
import TaskManagementDropdownSection from './TaskManagementDropdownSection'
import ReceiveInboundTask from './ReceiveInboundTask'
import {
  permissionObject,
  startPollingForIntake,
} from '../../utils/helperFunctions'
import moment from 'moment'
import { NestedTableComponent } from './NestedTableComponent'
import CallOutboundTask from './CallOutboundTask'
import {
  currentUserId,
  isReadOnlyUser,
  isSuperAdmin,
} from '../../utils/permission'
import { useSearchParams } from 'react-router-dom'
import { EligibilityAssessmentResultsTask } from './EligibilityAssessmentResultsTask'

import PAPCaptureInsuranceTask from './PAPCaptureInsuranceTask'
import DocumentPreviewTask from './DocumentPreviewTask'
import PapCaptureApiResponse from './PapCaptureApiResponse'
import { PharmacyTriageEligibilityAssessment } from './PharmacyTriageEligibilityAssessment'
import { PharmacyTriageOrderDetails } from './PharmacyTriageOrderDetails'
import { UpdateSPFillDetails } from './UpdateSPFillDetails'
import CallOutboundEntityLayoutTask from './CallOutboundEntityLayoutTask'
import CheckEligibilityMaxRTE from '../max-rte/CheckEligibilityMaxRTE'
import {
  CHECK_ELIGIBILITY_LOCATION,
  WORKFLOW_SUB_SERVICE_MAPPING,
} from '../../utils/maxRTE'
import PAPAppealReviewTask from './PAPAppealReviewTask'
import StartEndDateSelector from './StartEndDateSelector'
import NovoVoucherInfo from './NovoVoucherTask'
import CaptureShipmentRecordTask from './CaptureShipmentRecordTask'
import EprRetryManualPharmacyTask from './EprRetryManualPharmacyTask'
import CaptureVerbalConsentTask from './CaptureVerbalConsentTask'

import NPIStatusCustom from './NPIStatusCustom'
const EntityLayoutTask = lazy(() =>
  import('./EntityLayoutTask').then((module) => ({
    default: module.EntityLayoutTask,
  }))
)

export const MoveToMIModal: FC<MoveToMIProcessPropsType> = ({
  refetchWorkflow,
  recordId,
  closeFollowupTask,
  isMiMismatch,
  taskID,
}) => {
  const [missingInfoLayout, setMissingInfoLayout] =
    useState<LayoutResponseType>()
  const [caseData, setCaseData] = useState<FieldValues>()
  const dispatch = useAppDispatch()
  const workflowInstance = useAppSelector(
    (state) => state?.workflowData?.workflowInstance
  )
  const workflowDefinition = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const relationshipTree = useAppSelector(
    (state) => state?.workflowData?.relationshipTree
  )
  const programServices = useAppSelector(
    (state) => state?.clientPermissions?.programServices
  )

  const fetchEntityData = async () => {
    try {
      const response = await getEntityData(
        missingInfoLayout?.entity_name ?? '',
        missingInfoLayout?.entity_id ?? 0,
        missingInfoLayout?.id ?? 0,
        recordId
      )
      if (response?.data) {
        setCaseData(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchLayout = async () => {
    try {
      const response = await getLayoutByIdApi({
        entityId:
          workflowDefinition?.global_variables?.missing_info_popup?.entity_id,
        layoutId:
          workflowDefinition?.global_variables?.missing_info_popup?.layout_id,
      })
      if (response?.data) {
        setMissingInfoLayout(response.data)
        fetchEntityData()
      }
    } catch (err) {
      console.error(err)
    }
  }
  const completeTask = async () => {
    try {
      const meta_data = {}
      if (recordId) {
        const forced = true
        const programId =
          caseData?.programs?.id ?? workflowDefinition?.program_id
        const serviceId =
          caseData?.services?.id ?? workflowDefinition?.service_id
        if (
          !isSuperAdmin() &&
          !programServices[programId ?? '']?.includes(serviceId ?? 0)
        ) {
          await editEntityDataEmbeddedAPI(
            workflowDefinition?.global_variables?.entity_name ?? '',
            workflowInstance?.case_id?.toString() ?? '',
            {
              entityName:
                workflowDefinition?.global_variables?.entity_name ?? '',
              users: {
                _state: 'REMOVED',
              },
            },
            ['users']
          )
        }
        const res = await completeTaskByTaskIdApi({
          taskId: taskID ?? '',
          meta_data,
          forced,
        })
        if (
          res?.status === 202 ||
          res?.data?.instance?.state ===
            WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND
        ) {
          const poolingResponse: FieldValues = await startPollingForIntake({
            caseId: recordId ?? '',
          })
          res.data = {
            instance: poolingResponse?.workflow_instance,
            preRequisiteExecuted: true,
          }
          if (
            !isEmpty(poolingResponse?.workflow_instance?.background_response)
          ) {
            res.data.checkerResult =
              poolingResponse?.workflow_instance?.background_response ?? null
          }
        }

        if (res?.data) {
          dispatch(updateWorkflowInstance(res?.data?.instance))

          dispatch(
            addToaster({
              message: MISSING_INFO_CONSTANTS.TASK_SUCCESS_MSG,
              type: 'success',
              id: uuid(),
            })
          )
          closeFollowupTask?.()
          refetchWorkflow && refetchWorkflow()
        }
      }
    } catch (err) {
      dispatch(
        addToaster({
          message: MISSING_INFO_CONSTANTS.MSSING_INFO_PRESENT,
          type: 'error',
          id: uuid(),
        })
      )
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const handlSave = async (values: FieldValues) => {
    try {
      dispatch(showLoader())
      const workflowEntity = {
        entityId:
          workflowDefinition?.definition?.processVariables?.entity_id?.toString() ??
          '',
        entityName:
          workflowDefinition?.definition?.processVariables?.entity_name ?? '',
        layoutId:
          workflowDefinition?.definition?.processVariables?.left_split
            ?.edit_layout_id,
      }
      if (missingInfoLayout?.id) {
        const missingInfoEntity = relationshipTree?.find(
          (item) =>
            item?.entity_id?.toString() ===
            missingInfoLayout?.entity_id?.toString()
        )

        if (!isEmpty(missingInfoEntity)) {
          const finalData = {
            [missingInfoEntity?.field_name ?? '__null__']: [
              { ...values, _state: 'ADDED' },
            ],
          }
          const response = await editEntityData(
            workflowEntity?.entityName,
            workflowEntity?.entityId as unknown as number,
            workflowEntity?.layoutId as unknown as number,
            finalData,
            recordId
          )
          if (response?.data && !isMiMismatch) {
            const interruptResponse = await interruptWorkFlow({
              workflowId: workflowInstance?.id ?? '',
              signal:
                workflowDefinition?.global_variables?.stepper_config
                  ?.action_buttons?.missing_information?.signal ?? '',
            })
            if (interruptResponse?.data) {
              closeFollowupTask?.()
              refetchWorkflow && refetchWorkflow()
            }
          } else {
            completeTask()
          }
        }
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  useEffect(() => {
    if (!isEmpty(workflowDefinition)) {
      fetchLayout()
    }
  }, [workflowDefinition])

  return (
    <FormRenderer
      heading={<div></div>}
      layout={missingInfoLayout?.layout_data as LayoutData}
      mode={'add'}
      data={caseData}
      handleFormSubmit={handlSave}
      handleFormInvalid={(errors) => {
        console.log(errors)
      }}
      fullLayout={missingInfoLayout as EntityLayout}
      footer={
        <div className="flex gap-2 flex-row-reverse pt-3">
          <CustomButton type="submit" isFilled>
            {NAMESPACES?.SAVE_BUTTON}
          </CustomButton>
          <CustomButton
            type="button"
            onClick={() => {
              closeFollowupTask?.()
            }}
          >
            {NAMESPACES?.CANCEL_BUTTON}
          </CustomButton>
        </div>
      }
    />
  )
}

export const MoveToMIProcess: FC<MoveToMIProcessPropsType> = ({
  refetchWorkflow,
  recordId,
  tabIndex,
  isDisabled = false,
}) => {
  const workflowInstance = useAppSelector(
    (state) => state?.workflowData?.workflowInstance
  )
  const workflowDefinition = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const caseData = useAppSelector((state) => state?.workflowData?.caseData)
  const programPermissions = useAppSelector(
    (state) => state?.clientPermissions?.programPermissions
  )
  const updatedTaskList = useAppSelector(
    (state) => state?.workflowData?.taskList
  )
  const [isFollowUpTask, setIsFollowUpTask] = useState({ isOpen: false })

  const handleOnClick = async () => {
    setIsFollowUpTask({ isOpen: true })
  }

  const closeFollowupTask = () => {
    setIsFollowUpTask({ isOpen: false })
  }

  const isMoveToMIButtonVisible = () => {
    const hasPermission = permissionObject.Queue_Review_Manage(
      programPermissions,
      caseData?.programs?.id?.toString() ??
        workflowDefinition?.program_id?.toString() ??
        '',
      caseData?.services?.service_name ?? ''
    )
    let showHideButton = false
    const isNewFlow = workflowDefinition?.global_variables?.new_flow ?? false
    updatedTaskList?.forEach((task) => {
      if (
        workflowDefinition?.global_variables?.manual_mi?.step_id?.includes(
          task?.step_id ?? ''
        )
      ) {
        showHideButton = true
      }
    })
    return hasPermission && !isNewFlow && !showHideButton
  }

  useEffect(() => {
    isMoveToMIButtonVisible()
  }, [programPermissions, updatedTaskList])
  return (
    <>
      {!isEmpty(
        workflowDefinition?.global_variables?.stepper_config?.action_buttons?.[
          'missing_information'
        ]?.group
      ) &&
      workflowInstance?.current_group &&
      workflowDefinition?.global_variables?.stepper_config?.action_buttons?.[
        'missing_information'
      ]?.group?.includes(workflowInstance?.current_group) &&
      isMoveToMIButtonVisible() ? (
        <CustomButton
          isFilled
          onClick={handleOnClick}
          tabIndex={tabIndex}
          disabled={isDisabled}
        >
          {NAMESPACES?.MOVE_TO_MI}
        </CustomButton>
      ) : null}
      {isFollowUpTask?.isOpen ? (
        <Modal
          isOpen={isFollowUpTask?.isOpen}
          closeModal={() => setIsFollowUpTask({ isOpen: false })}
          modalHeader={NAMESPACES?.MOVE_TO_MI}
          width="min-w-[50%] w-fit max-w-[98%] z-[1]"
        >
          <MoveToMIModal
            refetchWorkflow={refetchWorkflow}
            recordId={recordId}
            closeFollowupTask={closeFollowupTask}
          />
        </Modal>
      ) : null}
    </>
  )
}

const MapTaskOnUiIdentifier: FC<MapTaskOnUiIdentifierPropsType> = ({
  task,
  recordId,
  updateTaskResource,
  reFetch,
  tabIndexOffset,
  taskList,
  isDisabled = false,
  uiIdentifierRef,
  refetchCounter,
  createTask,
}) => {
  const [resetState, setResetState] = useState<number>(0)
  if (
    task?.identifier?.ui_identifier !==
    WORKFLOW_UI_IDENTIFIER?.CUSTOM_ELIGIBILITY_LAYOUT
  )
    uiIdentifierRef.current = {
      ...uiIdentifierRef.current,
      [task?.id ?? '']: {
        updateCaseData: undefined,
      },
    }
  const stateUpdate = () => {
    setResetState((prev) => prev + 1)
  }
  useEffect(() => {
    window.addEventListener('EPR_PATIENT_UPDATED', stateUpdate)

    return () => {
      window.removeEventListener('EPR_PATIENT_UPDATED', stateUpdate)
    }
  }, [])

  const tabIndexOffsetValue = tabIndexOffset ? tabIndexOffset + 2 : undefined
  switch (task?.identifier?.ui_identifier) {
    case PHARMACY_RE_TRIAGE_UI_IDENTIFIER?.PTR_ELIGIBILITY_ASSESSMENT:
    case WORKFLOW_UI_IDENTIFIER.C_PAP_ACCESS_ELIGIBILITY:
      return (
        <PharmacyTriageEligibilityAssessment
          task={task}
          uiIdentifierRef={uiIdentifierRef}
        />
      )
    case PHARMACY_RE_TRIAGE_UI_IDENTIFIER.PTR_QUEUED_DATE:
      return <PharmacyTriageOrderDetails task={task} />
    case WORKFLOW_UI_IDENTIFIER.SP_FILL_STATUS_RECORD:
    case WORKFLOW_UI_IDENTIFIER.SP_FILL_STATUS_RECORD_FOLLOW_UP:
      return <UpdateSPFillDetails task={task} />
    case WORKFLOW_UI_IDENTIFIER?.CUSTOM_ELIGIBILITY_LAYOUT:
    case WORKFLOW_UI_IDENTIFIER.VOUCHER_ACCESS_ELIGIBILITY:
      return (
        <EligibilityAssessmentResultsTask
          task={task}
          uiIdentifierRef={uiIdentifierRef}
        />
      )
    case WORKFLOW_UI_IDENTIFIER?.GET_MAXRTE:
      return (
        <Suspense fallback={<div>{NAMESPACES?.LOADING_PLACEHOLDER}</div>}>
          <EntityLayoutTask
            task={task}
            recordId={recordId}
            isTask
            updateTaskResource={updateTaskResource}
            refetch={reFetch}
            tabIndexOffset={tabIndexOffsetValue}
            taskList={taskList}
            isDisabled={isDisabled}
            isMAXRTE={true}
            refetchCounter={refetchCounter}
          />
        </Suspense>
      )
    case WORKFLOW_UI_IDENTIFIER?.PAP_EXCEPTION_REVIEW_TASK:
    case WORKFLOW_UI_IDENTIFIER?.CUSTOM_LAYOUT_SCREEN:
    case WORKFLOW_UI_IDENTIFIER?.ENTITY_LAYOUT:
      return (
        <Suspense fallback={<div>{NAMESPACES?.LOADING_PLACEHOLDER}</div>}>
          <EntityLayoutTask
            task={task}
            recordId={recordId}
            isTask
            updateTaskResource={updateTaskResource}
            refetch={reFetch}
            tabIndexOffset={tabIndexOffsetValue}
            taskList={taskList}
            isDisabled={isReadOnlyUser() || isDisabled}
            refetchCounter={refetchCounter}
          />
        </Suspense>
      )
    case WORKFLOW_UI_IDENTIFIER.SP_RELAY_CALL_OUTBOUND:
      return (
        <Suspense fallback={<div>{NAMESPACES?.LOADING_PLACEHOLDER}</div>}>
          <CallOutboundEntityLayoutTask
            task={task}
            recordId={recordId}
            updateTaskResource={updateTaskResource}
            reFetch={reFetch}
            tabIndexOffset={tabIndexOffset}
            taskList={taskList}
            isDisabled={isReadOnlyUser() || isDisabled}
            refetchCounter={refetchCounter}
            uiIdentifierRef={uiIdentifierRef}
          />
        </Suspense>
      )
    case WORKFLOW_UI_IDENTIFIER?.PTR_CAPTURE_PHARMACY_DETAILS:
    case WORKFLOW_UI_IDENTIFIER?.EPR_HYBRID_LAYOUT:
      return (
        <Suspense fallback={<div>{NAMESPACES?.LOADING_PLACEHOLDER}</div>}>
          <EntityLayoutTask
            task={task}
            recordId={recordId}
            isTask
            updateTaskResource={updateTaskResource}
            refetch={reFetch}
            tabIndexOffset={tabIndexOffsetValue}
            taskList={taskList}
            isDisabled={isReadOnlyUser() || isDisabled}
            key={resetState}
          />
        </Suspense>
      )
    case WORKFLOW_UI_IDENTIFIER?.WORKFLOW_SUMMARY_TASK:
      return (
        <AddTask
          task={task}
          isRevalidate
          reFetch={reFetch}
          tabIndexOffset={tabIndexOffsetValue}
          isSummary
          isDisabled={isReadOnlyUser() || isDisabled}
          recordId={recordId}
        />
      )
    case WORKFLOW_UI_IDENTIFIER?.AUTO_SEND_COMMUNICATION_FAX:
    case WORKFLOW_UI_IDENTIFIER?.AUTO_SEND_COMMUNICATION_SMS:
      return (
        <SendCommunicationTask
          recordId={recordId}
          task={task}
          updateTaskResource={updateTaskResource}
          tabIndexOffset={tabIndexOffsetValue}
          isDisabled={task?.state !== WORKFLOW_STATUS.OPEN || isDisabled}
          workFlowUiIdentifier={task?.identifier?.ui_identifier}
          isAutoTask={true}
          refetch={reFetch}
          createTask={createTask}
        />
      )
    case WORKFLOW_UI_IDENTIFIER?.SEND_COMMUNICATION_FAX:
      return (
        <SendCommunicationTask
          recordId={recordId}
          task={task}
          updateTaskResource={updateTaskResource}
          tabIndexOffset={tabIndexOffsetValue}
          isDisabled={
            isReadOnlyUser() ||
            task?.state !== WORKFLOW_STATUS.OPEN ||
            isDisabled
          }
          refetch={reFetch}
          createTask={createTask}
        />
      )

    case WORKFLOW_UI_IDENTIFIER?.FAX_OUTBOUND_TASK:
    case WORKFLOW_UI_IDENTIFIER?.GENERATE_DOCUMENT:
    case WORKFLOW_UI_IDENTIFIER?.MANUAL_TEXT_OUTBOUND:
    case WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK:
      return (
        <SendCommunicationTask
          recordId={recordId}
          task={task}
          updateTaskResource={updateTaskResource}
          tabIndexOffset={tabIndexOffsetValue}
          isDisabled={isReadOnlyUser() || isDisabled}
          workFlowUiIdentifier={task?.identifier?.ui_identifier}
          createTask={createTask}
        />
      )
    case WORKFLOW_UI_IDENTIFIER.CALL_OUTBOUND_TASK:
    case WORKFLOW_UI_IDENTIFIER.SYSTEM_CALL_OUTBOUND:
    case WORKFLOW_UI_IDENTIFIER.MANUAL_CALL_OUTBOUND:
      return (
        <CallOutboundTask
          task={task}
          tabIndexOffset={tabIndexOffset}
          isDisabled={isReadOnlyUser() || isDisabled}
          updateTaskResource={updateTaskResource}
        />
      )
    case WORKFLOW_UI_IDENTIFIER?.ENTITY_LAYOUT_LIST:
      return null
    case WORKFLOW_UI_IDENTIFIER?.RE_VALIDATE:
      return (
        <AddTask
          task={task}
          isRevalidate
          reFetch={reFetch}
          tabIndexOffset={tabIndexOffsetValue}
          isDisabled={isReadOnlyUser() || isDisabled}
          recordId={recordId}
        />
      )
    case WORKFLOW_UI_IDENTIFIER?.NEW_CASE_HYPERLINK:
      return (
        <CaseCreatedTask
          task={task}
          reFetch={reFetch}
          tabIndexOffset={tabIndexOffsetValue}
        />
      )
    case WORKFLOW_UI_IDENTIFIER?.FAX_INBOUND_TASK:
    case WORKFLOW_UI_IDENTIFIER?.MAIL_INBOUND_TASK:
    case WORKFLOW_UI_IDENTIFIER?.WEB_INBOUND_TASK:
    case WORKFLOW_UI_IDENTIFIER?.INTERACTION_INBOUND_TASK:
      return (
        <ReceiveInboundTask
          task={task}
          reFetch={reFetch}
          tabIndexOffset={tabIndexOffsetValue}
          isDisabled={isReadOnlyUser() || isDisabled}
          recordId={recordId}
        />
      )
    case WORKFLOW_UI_IDENTIFIER?.NO_PREVIEW:
      return null
    case WORKFLOW_UI_IDENTIFIER?.PROVIDER_SIGNATURE:
      return (
        <SendConsentTask
          dataQaId={'provider-signature-button'}
          recipientType={NAMESPACES?.PROVIDER}
          task={task}
          tabIndex={tabIndexOffsetValue}
        />
      )
    case WORKFLOW_UI_IDENTIFIER?.PATIENT_SIGNATURE:
      return (
        <SendConsentTask
          dataQaId={'patient-signature-button'}
          recipientType={NAMESPACES?.PATIENT}
          task={task}
          tabIndex={tabIndexOffsetValue}
        />
      )
    case WORKFLOW_UI_IDENTIFIER.CUSTOM_ENROLLMENT_LAYOUT:
      return (
        <NestedTableComponent
          task={task}
          reFetch={reFetch}
          recordId={recordId}
          isDisabled={isDisabled}
          tabIndex={tabIndexOffsetValue ?? 0}
        />
      )
    case WORKFLOW_UI_IDENTIFIER?.CUSTOM_ENTITY_LAYOUT_TASK:
    case WORKFLOW_UI_IDENTIFIER?.GET_E_INCOME:
    case WORKFLOW_UI_IDENTIFIER.PAP_E_INCOME_TASK:
      return <PAPCaptureInsuranceTask recordId={recordId} task={task} />
    case WORKFLOW_UI_IDENTIFIER.DOCUMENT_PREVIEW_TASK:
      return <DocumentPreviewTask task={task} />
    case WORKFLOW_UI_IDENTIFIER.PAP_CAPTURE_API_RESPONSE:
      return (
        <PapCaptureApiResponse
          task={task}
          recordId={recordId}
          reFetch={reFetch}
        />
      )
    case WORKFLOW_UI_IDENTIFIER.NOVO_PAP_ORDER_LISTING_LAYOUT_TASK:
      return <CaptureShipmentRecordTask recordId={recordId} task={task} />
    case WORKFLOW_UI_IDENTIFIER.PAP_APPEAL_REVIEW_TASK:
      return <PAPAppealReviewTask recordId={recordId} task={task} />
    case WORKFLOW_UI_IDENTIFIER.NOVO_PAP_VOUCHER_LAYOUT_TASK:
      return (
        <NovoVoucherInfo
          task={task}
          recordId={recordId}
          isDisabled={isDisabled}
        />
      )
    case WORKFLOW_UI_IDENTIFIER.DATA_CHECK_LAYOUT:
    case WORKFLOW_UI_IDENTIFIER.DATA_CORRECTION_LAYOUT:
      return null
    case WORKFLOW_UI_IDENTIFIER.EPR_SELECT_LAYOUT:
      return (
        <EprRetryManualPharmacyTask
          task={task}
          recordId={recordId}
          isDisabled={isDisabled}
        />
      )
    case WORKFLOW_UI_IDENTIFIER.PROVIDER_NPI_STATUS_TASK:
      return (
        <NPIStatusCustom
          recordId={recordId}
          task={task}
          isDisabled={isDisabled}
        />
      )
    case WORKFLOW_UI_IDENTIFIER.CAPTURE_VERBAL_CONSENT:
      return (
        <CaptureVerbalConsentTask
          task={task}
          caseRecordId={recordId}
          isDisabled={isReadOnlyUser() || isDisabled}
          updateTaskResource={updateTaskResource}
        />
      )
    default:
      return (
        <AddTask
          task={task}
          reFetch={reFetch}
          tabIndexOffset={tabIndexOffsetValue}
          isDisabled={isReadOnlyUser() || isDisabled}
          recordId={recordId}
        />
      )
  }
}

const ReValidateTask: FC<WorkflowRevalidateTaskPropsType> = ({
  task,
  handleTaskResponse,
  tabIndex,
  isDisabled,
}) => {
  const [isCheckSuccess, setIsCheckSuccess] = useState<boolean>(false)
  const workflowDefinition = useAppSelector(
    (state) => state.workflowData.workflowDefinition
  )
  const completeTask = async () => {
    try {
      let meta_data: { entityId?: string; layoutId?: string } = {}
      let forced =
        task?.identifier?.forced === 'FALSE' && !isCheckSuccess
          ? false
          : !workflowDefinition?.definition?.steps?.[task?.step_id ?? '']
              ?.preRequisite
      let isPrerequisite = false
      if (
        !isEmpty(
          workflowDefinition?.definition?.steps?.[task?.step_id ?? '']
            ?.preRequisite
        )
      ) {
        isPrerequisite = true
        meta_data = {
          entityId: task?.identifier?.entity_id,
          layoutId: task?.identifier?.layout_info?.layout_id,
        }
        forced =
          !!workflowDefinition?.definition?.steps?.[task?.step_id ?? '']
            ?.preRequisite?.canForced
      }
      const taskResponse = await completeTaskByTaskIdApi({
        taskId: task?.id ?? '',
        meta_data,
        forced,
      })
      if (
        taskResponse?.status === 202 ||
        taskResponse?.data?.instance?.state ===
          WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND
      ) {
        const poolingResponse: FieldValues = await startPollingForIntake({
          caseId: task?.case_id ?? '',
        })
        taskResponse.data = {
          instance: poolingResponse?.workflow_instance,
          preRequisiteExecuted: isPrerequisite,
        }
        if (!isEmpty(poolingResponse?.workflow_instance?.background_response)) {
          taskResponse.data.checkerResult =
            poolingResponse?.workflow_instance?.background_response ?? null
        }
      }
      if (taskResponse?.data) {
        if (taskResponse?.data?.checkerResult?.status === 'SUCCESS') {
          setIsCheckSuccess(true)
        }
        handleTaskResponse?.(taskResponse?.data, true, task || null)
      }
    } catch (err) {
      console.error(err)
    }
  }
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault()
        completeTask()
      }}
      tabIndex={tabIndex ?? 0}
      onKeyDown={(e) => {
        if (e.key === ShortcutKeys.Enter || e.key === ShortcutKeys.Space) {
          e?.stopPropagation()
          e?.preventDefault()
          completeTask()
        }
      }}
      disabled={isDisabled}
      className={`flex bg-transparent border-0 p-0 ${
        isDisabled ? ' cursor-not-allowed' : 'cursor-pointer'
      }`}
      aria-label="Revalidate task"
    >
      <Tooltip content={NAMESPACES?.REVALIDATE} className="text-ellipsis">
        <SvgRevalidate />
      </Tooltip>
    </button>
  )
}

const WorkflowRightSplitTaskTable: FC<WorkflowRightSplitTaskTablePropsType> = ({
  recordId,
  reFetch,
  refetchWorkflow,
  overallCaseStatus,
  createTask,
}) => {
  const maxRTERef = useRef<IMaxRTEButton | null>(null)
  const unassignToasterRef = useRef<boolean>(false)

  const [taskResponseModal, setTaskResponseModal] = useState<{
    isOpen: boolean
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    workflow: any
    task?: WorkflowInstanceTaskType | null
    resetTaskListData?: () => void
  }>({
    isOpen: false,
    workflow: null,
  })
  const uiIdentifierRef = useRef<{
    [key: string]: { updateCaseData?: () => Promise<boolean> }
  }>({})
  const handleSaveDetails = async (taskId: string) => {
    if (uiIdentifierRef?.current?.[taskId]?.updateCaseData) {
      return (await uiIdentifierRef.current[taskId].updateCaseData?.()) ?? false
    } else return true
  }
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const taskIdFromQuery = searchParams.get('TASK_ID')
  const taskKeyFromQuery = searchParams.get('TASK_KEY')
  const taskId = taskIdFromQuery ? Number(taskIdFromQuery) : undefined
  const [taskList, setTaskList] = useState<WorkflowInstanceTaskType[]>([])
  const [refetchCounter, setRefetchCounter] = useState<number>(0)
  const WorkFlowTaskStatusData = useAppSelector(
    (state: RootState) => state.workflowTaskStatus?.workflowTaskStates
  )
  const workflowInstance = useAppSelector(
    (state) => state?.workflowData?.workflowInstance
  )
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions?.programPermissions
  )
  const caseData = useAppSelector(
    (state: RootState) => state.workflowData?.caseData
  )
  const maxRTEAutoTriggered = useAppSelector(
    (state) => state?.maxRte?.maxRTEAutotriggered
  )
  const userId = useAppSelector((state: RootState) => state?.authUser?.user?.id)
  const {
    control,
    formState: { errors },
    setValue,
    register,
    watch,
  } = useForm()
  const [assigneeOptions, setAssigneeOptions] = useState<
    { label: string; value: string }[]
  >([])
  const [permissionAssigneeOptions, setPermissionAssigneeOptions] = useState<{
    [key: string]: { label: string; value: string }[]
  }>()
  const permissionNameIdMapping = useAppSelector(
    (state) => state?.allPermissions?.permissions
  )
  const assigneeOptionsref = useRef<{
    [key: string]: boolean
  }>({})
  const serviceAssigneeFetchKeyRef = useRef<string | null>(null)

  const workflowDefinition = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const fetchTasklist = async () => {
    dispatch(showLoader())
    try {
      const response = await getTaskListApi({
        search_criteria: [
          {
            search_key: 'CASE_ID',
            search_value: [recordId],
            operator: 'EQUALS',
          },
        ],
      })
      if (response?.data) {
        const stickyData =
          response?.data?.content?.filter(
            (val: WorkflowInstanceTaskType) => val?.identifier?.is_sticky
          ) ?? []
        const newArray =
          response?.data?.content
            ?.filter(
              (val: WorkflowInstanceTaskType) => !val?.identifier?.is_sticky
            )
            .sort(
              (
                taskA: WorkflowInstanceTaskType,
                taskB: WorkflowInstanceTaskType
              ) => {
                if (!taskA?.task_id || !taskB?.task_id) return 0
                return Number(taskB?.task_id) - Number(taskA?.task_id) //TODO: confirm if this logic is correct
              }
            ) ?? []
        newArray?.forEach(async (task: WorkflowInstanceTaskType) => {
          if (
            task?.identifier?.ui_identifier ===
            WORKFLOW_UI_IDENTIFIER?.GET_MAXRTE
          ) {
            if (task?.state === WORKFLOW_STATUS?.PENDING) {
              await completeTaskByTaskIdApi({
                taskId: task?.id ?? '',
                meta_data: {
                  entityId: task?.identifier?.entity_id,
                  layoutId: task?.identifier?.layout_info?.layout_id,
                },
                forced: true,
                changeStatus: WORKFLOW_STATUS?.OPEN,
              })
              fetchTasklist()
              return
            }
          }
        })

        setTaskList(stickyData.length ? [...stickyData, ...newArray] : newArray)
        dispatch(
          updateTaskList(
            stickyData.length ? [...stickyData, ...newArray] : newArray
          )
        )
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
      setRefetchCounter((prev) => prev + 1)
    }
  }

  const handleModalClose = () => {
    setTaskResponseModal({ isOpen: false, workflow: null, task: null })
  }

  const handleTaskResponse = (
    workflowData: WorkflowTaskCompleteResponseType,
    open = false,
    task?: WorkflowInstanceTaskType | null,
    resetTaskListData?: () => void
  ) => {
    setTaskResponseModal({
      isOpen: open,
      workflow: workflowData,
      task: task || null,
      resetTaskListData: resetTaskListData,
    })
  }
  const updateTaskResource = async (
    task: WorkflowInstanceTaskType | null,
    taskMeta: FieldValues
  ) => {
    try {
      const response = await taskUpdateApi(
        {
          taskId: task?.id ?? '',
          data: {
            communication_id: taskMeta?.communication_id,
            resource_id: taskMeta?.resource_id,
            ...(taskMeta?.resource && {
              resource: taskMeta.resource,
            }),
            outcome: task?.outcome
              ? task.outcome
              : WORKFLOW_OUTCOMES.IN_PROGRESS_KEY,
            ...(taskMeta?.notes && { notes: taskMeta?.notes }),
            ...(taskMeta?.template_id && {
              identifier: {
                ...task?.identifier,
                template_id: taskMeta?.template_id,
                template: {
                  ...task?.identifier?.template,
                  id: taskMeta?.template_id,
                },
              },
            }),
          },
        },
        caseData?.programs?.id?.toString(),
        caseData?.services?.id?.toString()
      )
      if (response?.data) {
        // fetchTasklist()
        refetchWorkflow()
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchDataForTaskStatus = async () => {
    try {
      const data = await fetchTaskStatus()
      dispatch(setWorkflowStatus(data?.data))
    } catch (error) {
      console.error(error)
    }
  }

  const fetchAssigneeName = async () => {
    try {
      const program_id =
        caseData?.programs?.id ?? workflowDefinition?.program_id
      const service_id =
        caseData?.services?.id ??
        workflowDefinition?.global_variables?.inherited_variables?.service_id
      const assigneeResponse = await fetchAssigneeApi(
        Number(service_id),
        Number(program_id)
      )
      const assigneeOptions = assigneeResponse?.data?.map(
        (assignee: [number, string, string]) => ({
          label: `${assignee[1]} ${assignee[2]}`,
          value: String(assignee[0]),
        })
      )
      setAssigneeOptions([
        { label: NAMESPACES.UNASSIGNED, value: NAMESPACES.UNASSIGNED },
        ...(assigneeOptions ?? []),
      ])
    } catch (error) {
      console.error(error)
    }
  }

  const fetchAssigneeOptions = (task: WorkflowInstanceTaskType) => {
    const permissionName = task?.identifier?.task_permission ?? ''
    return permissionAssigneeOptions?.[permissionName] ?? []
  }

  const handleAssigneeChange = async (
    selectedOption: { value: string; label: string },
    task: WorkflowInstanceTaskType
  ) => {
    if (task?.state !== WORKFLOW_STATUS?.COMPLETED) {
      let payload: TaskPayload

      if (selectedOption?.value === NAMESPACES.UNASSIGNED) {
        payload = {
          id: Number(task?.id),
          assignee: { id: -1 },
        }
      } else {
        payload = {
          id: Number(task?.id),
          assignee: { id: Number(selectedOption?.value) },
        }
      }
      try {
        await saveTaskDataApi(
          task?.id as string,
          payload,
          caseData?.programs?.id?.toString(),
          caseData?.services?.id?.toString()
        )
        const subServiceId =
          workflowDefinition?.definition?.processVariables?.inherited_variables
            ?.sub_service_id
        if (
          selectedOption?.value === NAMESPACES.UNASSIGNED &&
          task?.identifier?.show_toaster_on_unassignment === true
        ) {
          dispatch(
            addToaster({
              id: uuid(),
              message:
                subServiceId ===
                WORKFLOW_SUB_SERVICE_MAPPING?.PAP_NEW_ENROLLMENT //for PAP New Enrollment
                  ? NAMESPACES.CASES_ROUTED_FOR_EXCEPTION_PAP
                  : subServiceId === WORKFLOW_SUB_SERVICE_MAPPING?.PAP_APPEAL //for PAP Appeal
                  ? NAMESPACES.CASES_ROUTED_FOR_EXCEPTION_APPEAL
                  : '',
              type: 'success',
            })
          )
        }
      } catch (error) {
        console.error(error)
      }
      fetchTasklist()
    }
  }

  const hasEditPermission = (task: WorkflowInstanceTaskType) => {
    const hasServicePermission = permissionObject.Manage_Workflow(
      programPermissions,
      caseData,
      task,
      userId ?? ''
    )
    const hasIdentifierKey = task?.identifier?.task_permission
    if (hasIdentifierKey) {
      const hasTaskEditPermission =
        programPermissions[
          caseData?.programs?.id ?? workflowDefinition?.program_id ?? ''
        ]?.[hasIdentifierKey]?.Manage === true
      return hasTaskEditPermission
    } else {
      return hasServicePermission
    }
  }

  const hasAssigneeDropdownPermission = (task: WorkflowInstanceTaskType) => {
    const hasServicePermission = permissionObject.Manage_Workflow(
      programPermissions,
      caseData,
      task,
      userId ?? ''
    )
    const hasIdentifierKey = task?.identifier?.task_permission
    if (hasIdentifierKey) {
      const hasTaskEditPermission =
        programPermissions[workflowDefinition?.program_id ?? '']?.[
          hasIdentifierKey
        ]?.Manage === true
      return currentUserId() === caseData?.users?.id || hasTaskEditPermission
    } else {
      return hasServicePermission
    }
  }

  const handleProceedClick = async () => {
    if (
      !workflowDefinition?.global_variables?.stepper_config?.action_buttons
        ?.missing_information?.signal
    )
      return
    const taskId =
      taskResponseModal?.workflow?.taskId?.toString() ??
      taskResponseModal?.task?.id?.toString()
    const isIntakeLayout = taskResponseModal?.task?.identifier?.is_intake_layout
    try {
      dispatch(showLoader())
      const taskResponse = await completeTaskByTaskIdApi({
        taskId,
        meta_data: {},
        forced: true,
      })
      if (
        taskResponse?.status === 202 ||
        taskResponse?.data?.instance?.state ===
          WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND
      ) {
        await startPollingForIntake({
          caseId: recordId ?? '',
        })
      }
      if (
        !isIntakeLayout &&
        !taskResponseModal?.workflow?.checkerResult?.quickDenialDetails?.denied
      ) {
        await interruptWorkFlow({
          workflowId: workflowInstance?.id ?? '',
          signal:
            taskResponseModal?.task?.identifier?.custom_signal ??
            workflowDefinition?.global_variables?.stepper_config?.action_buttons
              ?.missing_information?.signal,
        })
      }
      fetchTasklist?.()
      refetchWorkflow && refetchWorkflow()
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
      handleModalClose()
    }
  }

  const isTaskStatusDisabled = (task: WorkflowInstanceTaskType) => {
    const isDataCheckCompletedTask =
      (task?.identifier?.ui_identifier ===
        WORKFLOW_UI_IDENTIFIER?.DATA_CHECK_LAYOUT ||
        task?.identifier?.ui_identifier ===
          WORKFLOW_UI_IDENTIFIER.DATA_CORRECTION_LAYOUT) &&
      task?.state === WORKFLOW_STATUS.COMPLETED
    if (isDataCheckCompletedTask) return true
    return (
      isReadOnlyUser() ||
      (task?.standalone &&
      task?.state !== WORKFLOW_STATUS.CANCELLED &&
      task?.state !== WORKFLOW_STATUS.COMPLETED &&
      overallCaseStatus === STRINGS.CLOSED
        ? false
        : overallCaseStatus === STRINGS.CLOSED ||
          overallCaseStatus === STRINGS.VOID) ||
      !hasEditPermission(task)
    )
  }

  const programId = caseData?.programs?.id ?? workflowDefinition?.program_id
  const serviceId =
    caseData?.services?.id ??
    workflowDefinition?.global_variables?.inherited_variables?.service_id

  useEffect(() => {
    if (!programId || !serviceId) return

    const fetchKey = `${programId}-${serviceId}`
    if (serviceAssigneeFetchKeyRef.current === fetchKey) return
    serviceAssigneeFetchKeyRef.current = fetchKey

    fetchAssigneeName()
  }, [programId, serviceId])

  useEffect(() => {
    if (!programId || !taskList?.length || !permissionNameIdMapping?.length) {
      return
    }

    const permissionNames = [
      ...new Set(
        taskList
          .map((task) => task?.identifier?.task_permission)
          .filter((name): name is string => Boolean(name))
      ),
    ]

    permissionNames.forEach((permissionName) => {
      if (assigneeOptionsref.current[permissionName]) return

      assigneeOptionsref.current = {
        ...assigneeOptionsref.current,
        [permissionName]: true,
      }

      const permissionId = permissionNameIdMapping.find(
        (item) => item.name === permissionName
      )?.id
      if (!permissionId) return

      fetchAssigneeApiForPermissions(permissionId, Number(programId))
        .then((assignees) => {
          const permissionAssigneeOps = assignees?.data?.map(
            (assignee: [number, string, string]) => ({
              label: `${assignee[1]} ${assignee[2]}`,
              value: String(assignee[0]),
            })
          )
          setPermissionAssigneeOptions((prev) => ({
            ...prev,
            [permissionName]: [
              { label: NAMESPACES.UNASSIGNED, value: NAMESPACES.UNASSIGNED },
              ...(permissionAssigneeOps ?? []),
            ],
          }))
        })
        .catch((error) => {
          console.error(error)
          assigneeOptionsref.current = {
            ...assigneeOptionsref.current,
            [permissionName]: false,
          }
        })
    })
  }, [taskList, programId, permissionNameIdMapping])

  useEffect(() => {
    fetchTasklist()
  }, [reFetch])

  useEffect(() => {
    if (!WorkFlowTaskStatusData?.length) fetchDataForTaskStatus()
    return () => {
      dispatch(updateMaxRTEAutotriggered(false))
    }
  }, [])

  useEffect(() => {
    if (taskList?.length > 0) {
      if (taskKeyFromQuery) {
        setTimeout(() => {
          const containerTop = document
            .querySelector(`.task_list_container`)
            ?.getBoundingClientRect()?.top
          const elementTop = document
            .querySelector(`.task_key_${taskKeyFromQuery}`)
            ?.getBoundingClientRect()?.top
          if (containerTop && elementTop) {
            const diff = elementTop - containerTop + 17
            document
              .querySelector(`.task_list_container_outer`)
              ?.scrollTo(0, diff)
          }
        }, 2000)
      }
    }
  }, [taskList])

  useEffect(() => {
    taskList?.forEach((task) => {
      if (
        task?.state === WORKFLOW_STATUS?.OPEN &&
        task?.identifier?.ui_identifier === WORKFLOW_UI_IDENTIFIER?.GET_MAXRTE
      ) {
        if (
          maxRTERef.current?.triggerCheckEligibility &&
          !maxRTEAutoTriggered
        ) {
          maxRTERef.current.triggerCheckEligibility()
          dispatch(updateMaxRTEAutotriggered(true))
        }
      }
    })

    const allPendingTasks = taskList?.filter(
      (task) => task?.state === WORKFLOW_STATUS.PENDING
    )

    allPendingTasks?.forEach((task) => {
      if (
        task?.identifier?.show_toaster_on_unassignment === true &&
        isEmpty(task?.assignee) &&
        unassignToasterRef.current === false
      ) {
        const subServiceId =
          workflowDefinition?.definition?.processVariables?.inherited_variables
            ?.sub_service_id
        dispatch(
          addToaster({
            id: uuid(),
            message:
              subServiceId === WORKFLOW_SUB_SERVICE_MAPPING?.PAP_NEW_ENROLLMENT //for PAP New Enrollment
                ? NAMESPACES.CASES_ROUTED_FOR_EXCEPTION_PAP
                : subServiceId === WORKFLOW_SUB_SERVICE_MAPPING?.PAP_APPEAL //for PAP Appeal
                ? NAMESPACES.CASES_ROUTED_FOR_EXCEPTION_APPEAL
                : '',
            type: 'success',
          })
        )
        unassignToasterRef.current = true
      }
    })
  }, [taskList])

  const isAnyRevalidateVisible = taskList?.some(
    (task) =>
      task?.identifier?.ui_identifier === WORKFLOW_UI_IDENTIFIER?.RE_VALIDATE &&
      task?.state !== WORKFLOW_STATUS?.COMPLETED
  )

  const columnStyles = isAnyRevalidateVisible
    ? 'grid grid-cols-[8.75%_24.5%_12.25%_12.25%_12.25%_12.25%_11.75%_2.5%_3%] items-center whitespace-nowrap w-full gap-1'
    : 'grid grid-cols-[9.09%_25%_12.645%_12.645%_12.645%_12.645%_11.93%_3.41%] items-center whitespace-nowrap w-full gap-1'

  return (
    <div className="flex mt-1 w-full">
      <div className="overflow-x-auto w-full flex flex-col overflow-y-hidden gap-2">
        <Accordion
          alwaysOpen
          borderColor="primary-500"
          isConditional
          className="bg-tertiary-100 !border-l-0 !border-none"
          accordianHeightPadding="min-h-9 pl-1 pr-4"
          tabIndex={ROWS_TAB_DIFFERENCE_FOR_WORK_FOW}
          heading={
            <div
              className={
                columnStyles +
                ' bg-tertiary-100 text-xs font-primary font-normal py-2 w-full h-full items-center'
              }
            >
              <div className="truncate h-full border-accent-0 flex justify-between">
                {NAMESPACES?.TASK_ID}
              </div>
              <div className="truncate">{NAMESPACES?.TASK_NAME}</div>
              <div className="truncate">{NAMESPACES?.START_DATE}</div>
              <div className="truncate">{NAMESPACES?.DUE_DATE}</div>
              <div className="truncate">{NAMESPACES?.COMPLETION_DATE}</div>
              <div className="truncate">{NAMESPACES?.ASSIGNEE}</div>
              <div className="truncate">{NAMESPACES?.STATUS}</div>
              {workflowDefinition?.global_variables
                ?.show_task_reload_button && (
                <div
                  className="truncate"
                  onClick={() => {
                    fetchTasklist()
                    refetchWorkflow()
                  }}
                >
                  <SvgReload />
                </div>
              )}

              {/* <div className="border w-full"></div> */}
            </div>
          }
        >
          <></>
        </Accordion>

        {/* Accordion Rows */}
        <div className="flex flex-col flex-1 min-h-0 overflow-y-auto">
          {!isEmpty(taskList) &&
            taskList?.map((task, index) =>
              task.show_on_ui ?? true ? (
                <React.Fragment key={`${task?.name}_${task?.id}`}>
                  <StickyHeaderAccordion
                    borderColor={'primary-500'}
                    isConditional
                    className="bg-secondary-50"
                    headerClassName={`z-40 focus-within:z-50 task_key_T-${task?.id}`}
                    heading={
                      <div className={columnStyles}>
                        <span className="truncate font-light text-xs">
                          T - {task?.task_id}
                        </span>
                        <span className="truncate">
                          <Tooltip
                            content={task?.name}
                            className="text-ellipsis"
                          >
                            <div className="truncate w-full font-light text-xs">
                              {task?.name}
                            </div>
                          </Tooltip>
                        </span>
                        <StartEndDateSelector
                          task={task}
                          index={index}
                          overallCaseStatus={overallCaseStatus}
                          hasEditPermission={hasEditPermission}
                        />

                        {task?.identifier?.ui_identifier ===
                        WORKFLOW_UI_IDENTIFIER?.GET_MAXRTE ? (
                          <div className="absolute invisible">
                            <CheckEligibilityMaxRTE
                              from={CHECK_ELIGIBILITY_LOCATION.CASE}
                              showTextButton={false}
                              showDivider={false}
                              ref={maxRTERef}
                            />
                          </div>
                        ) : null}

                        <span className="truncate font-light text-xs">
                          <Tooltip
                            content={
                              task?.completion_date
                                ? moment(task.completion_date).format(
                                    DATE_INPUT_CONSTANTS.COMMON_DATE_TIME_FORMAT_2
                                  )
                                : ''
                            }
                            className="text-ellipsis max-w-[100%]"
                            cssClassName="max-w-[100%]"
                          >
                            <div className="mx-1 overflow-hidden text-ellipsis whitespace-nowrap">
                              {task?.completion_date
                                ? moment(task.completion_date).format(
                                    DATE_INPUT_CONSTANTS.COMMON_DATE_TIME_FORMAT_2
                                  )
                                : '-'}
                            </div>
                          </Tooltip>
                        </span>
                        <span
                          className="truncate w-full"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <ControlledDropDown
                            dataQaId={`${task?.id}_${task?.name}_assignee_drop`}
                            control={control}
                            required={true}
                            name={`${task?.id}_${task?.name}_assignee`}
                            placeholder="Select"
                            className="w-full bg-accent-0"
                            height="h-[0.8rem]"
                            isCrossable={false}
                            options={
                              task?.assignee?.id &&
                              !(
                                task?.identifier?.task_permission
                                  ? fetchAssigneeOptions(task)
                                  : assigneeOptions
                              ).find(
                                (option) =>
                                  option.value === String(task?.assignee?.id)
                              )
                                ? [
                                    ...(task?.identifier?.task_permission
                                      ? fetchAssigneeOptions(task)
                                      : assigneeOptions),
                                    {
                                      label: `${task?.assignee?.first_name} ${task?.assignee?.last_name}`,
                                      value: String(task?.assignee?.id),
                                    },
                                  ]
                                : task?.identifier?.task_permission
                                ? fetchAssigneeOptions(task)
                                : assigneeOptions
                            }
                            onChange={(selectedOption) =>
                              handleAssigneeChange(selectedOption, task)
                            }
                            defaultValue={
                              task?.assignee
                                ? String(task?.assignee?.id)
                                : NAMESPACES.UNASSIGNED
                            }
                            disabled={
                              isReadOnlyUser() ||
                              (task?.standalone &&
                              task?.state !== WORKFLOW_STATUS.CANCELLED &&
                              task?.state !== WORKFLOW_STATUS.COMPLETED &&
                              overallCaseStatus === STRINGS.CLOSED
                                ? false
                                : overallCaseStatus === STRINGS.CLOSED ||
                                  overallCaseStatus === STRINGS.VOID ||
                                  task?.state === WORKFLOW_STATUS?.COMPLETED) ||
                              !hasAssigneeDropdownPermission(task)
                            }
                            isSearchable={true}
                            customPadding="!px-1"
                            tabIndex={
                              ROWS_TAB_DIFFERENCE_FOR_WORK_FOW * (index + 1) + 1
                            }
                          />
                        </span>
                        <span className="truncate">
                          <WorkflowTaskStatus
                            task={task}
                            taskId={task?.id ?? ''}
                            status={task?.state ?? ''}
                            reFetch={() => {
                              refetchWorkflow()
                              fetchTasklist()
                            }}
                            fetchTasklist={fetchTasklist}
                            handleTaskResponse={handleTaskResponse}
                            tabIndex={
                              ROWS_TAB_DIFFERENCE_FOR_WORK_FOW * (index + 1) + 1
                            }
                            isDisabled={isTaskStatusDisabled(task)}
                            recordId={recordId}
                            handleSaveDetails={handleSaveDetails}
                            showToaster={
                              index === 0 &&
                              task?.state === WORKFLOW_STATUS.COMPLETED &&
                              task?.identifier?.layout_info?.showToaster
                            }
                            overallCaseStatus={overallCaseStatus}
                          />
                        </span>
                        <div className="font-primary text-xs font-normal">
                          {WORKFLOW_UI_IDENTIFIER?.RE_VALIDATE ===
                            task?.identifier?.ui_identifier &&
                          task?.state !== WORKFLOW_STATUS?.COMPLETED ? (
                            <ReValidateTask
                              task={task}
                              handleTaskResponse={handleTaskResponse}
                              tabIndex={
                                ROWS_TAB_DIFFERENCE_FOR_WORK_FOW * (index + 1) +
                                1
                              }
                              isDisabled={
                                isReadOnlyUser() ||
                                (task?.standalone &&
                                task?.state !== WORKFLOW_STATUS.CANCELLED &&
                                task?.state !== WORKFLOW_STATUS.COMPLETED &&
                                overallCaseStatus === STRINGS.CLOSED
                                  ? false
                                  : overallCaseStatus === STRINGS.CLOSED ||
                                    overallCaseStatus === STRINGS.VOID)
                              }
                            />
                          ) : null}
                        </div>
                      </div>
                    }
                    accordianHeightPadding="min-h-9 pl-1 pr-4"
                    tabIndex={ROWS_TAB_DIFFERENCE_FOR_WORK_FOW * (index + 1)}
                    isDisabled={
                      task?.identifier?.ui_identifier ===
                        WORKFLOW_UI_IDENTIFIER?.NO_PREVIEW ||
                      overallCaseStatus === STRINGS.VOID
                    }
                    isDefaultActive={
                      task?.id === taskId ||
                      (task.state === WORKFLOW_STATUS.OPEN &&
                        !taskKeyFromQuery) ||
                      `T-${task?.task_id}` === taskKeyFromQuery
                    }
                    key={task?.state}
                    subHeading={
                      <TaskManagementDropdownSection
                        task={task}
                        setValue={setValue}
                        control={control}
                        errors={errors}
                        register={register}
                        isTaskCompleted={
                          isReadOnlyUser() ||
                          (task?.standalone &&
                          task?.state !== WORKFLOW_STATUS.CANCELLED &&
                          task?.state !== WORKFLOW_STATUS.COMPLETED &&
                          overallCaseStatus === STRINGS.CLOSED
                            ? false
                            : task?.state === WORKFLOW_STATUS?.COMPLETED ||
                              overallCaseStatus === STRINGS.CLOSED ||
                              overallCaseStatus === STRINGS.VOID)
                        }
                        reFetch={() => {
                          fetchTasklist()
                        }}
                        watch={watch}
                      />
                    }
                  >
                    <div>
                      <MapTaskOnUiIdentifier
                        task={task}
                        recordId={recordId}
                        reFetch={() => {
                          refetchWorkflow()
                          fetchTasklist()
                        }}
                        refetchCounter={refetchCounter}
                        updateTaskResource={updateTaskResource}
                        tabIndexOffset={
                          ROWS_TAB_DIFFERENCE_FOR_WORK_FOW * (index + 1)
                        }
                        taskList={taskList}
                        isDisabled={
                          isReadOnlyUser() ||
                          (task?.standalone &&
                            task?.state !== WORKFLOW_STATUS.CANCELLED &&
                            task?.state !== WORKFLOW_STATUS.COMPLETED &&
                            overallCaseStatus === STRINGS.CLOSED &&
                            task?.state === WORKFLOW_STATUS.OPEN)
                            ? false
                            : overallCaseStatus === STRINGS.CLOSED ||
                              overallCaseStatus === STRINGS.VOID ||
                              task?.state !== WORKFLOW_STATUS.OPEN
                        }
                        uiIdentifierRef={uiIdentifierRef}
                        createTask={createTask}
                      />
                    </div>
                  </StickyHeaderAccordion>
                  <div className="p-1 bg-white z-40" />
                </React.Fragment>
              ) : null
            )}
        </div>
      </div>

      {taskResponseModal?.isOpen && (
        <MissingInformationModal
          taskResponseModal={taskResponseModal}
          handleProceedClick={handleProceedClick}
          handleModalClose={handleModalClose}
          showButtons={false}
          fetchTasklist={fetchTasklist}
          refetchWorkflow={refetchWorkflow}
          resetTaskList={taskResponseModal?.resetTaskListData}
        />
      )}
    </div>
  )
}

export default WorkflowRightSplitTaskTable
